<template>
  <div>
    <div v-if="isLoading" class="flex items-center justify-center h-52">
      <aha-spinner size="lg" variant="tail" />
    </div>

    <template v-if="!isLoading">
      <ErrorSlideCopy v-if="hasError" @getAllUserPresentationsAndFolders="loadData" />
      <Folders
        v-if="hasPresentationToCopyTo"
        :selectedPresentationId="presentationId"
        :folders="displayedSharedFolders"
        :presentations="displayedSharedPresentations"
        @handlePresentationItemClick="handlePresentationItemClick"
      ></Folders>
      <template v-if="!hasError">
        <NoPresentationSlideCopy v-if="!hasPresentationToCopyTo" />
      </template>
    </template>
    <slot v-if="hasPresentationToCopyTo" name="interactive-button-section">
    </slot>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { groupBy, flatMap } from 'lodash'
import TabBaseMixin from './TabBaseMixin'
import Folders from './Folders.vue'

export default {
  name: 'TabSharedPresentations',
  title: 'Shared with Me',
  components: {
    Folders,
  },
  mixins: [TabBaseMixin],
  computed: {
    ...mapGetters('presentationsModule', ['sharedPresentations', 'sharedFolders']),
    displayedSharedPresentations() {
      // Exclude the current presentation
      return this.sharedPresentations?.filter((p) => p.id !== this.presentation.id)
    },
    displayedSharedFolders() {
      return this.reorderFolders(this.sharedFolders)
    },
    hasPresentationToCopyTo() {
      return this.displayedSharedPresentations.length > 0
    },
  },
  methods: {
    ...mapActions('presentationsModule', ['getSharedPresentationsAction', 'getSharedFoldersAction']),
    async loadData() {
      return Promise.all([this.getSharedFoldersAction(), this.getSharedPresentationsAction()])
    },
    collectChildren(folder, foldersByParent) {
      let ordered = [folder]
      const children = foldersByParent[folder.folderId] || []

      children.forEach((child) => {
        ordered = ordered.concat(this.collectChildren(child, foldersByParent))
      })

      return ordered
    },
    reorderFolders(folders) {
      // Group folders by parentFolderId for quick lookup
      const foldersByParent = groupBy(folders, 'parentFolderId')

      // Find root folders (those without a parentFolderId)
      const rootFolders = foldersByParent[undefined] || foldersByParent.null

      // Recursively collect all folders in the correct order
      return flatMap(rootFolders, (root) => this.collectChildren(root, foldersByParent))
    },
  },
}
</script>
